import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { vppsAPI } from "../api/api";
import { VppsActionTypes } from "../actions/actionTypes";
import _ from "lodash";

function* getVpps(action) {
    try {
        const vppsResponse = yield call(() =>
            vppsAPI.getVpps({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top,
                search: action.payload.search,
                subsidiaries: action.payload.subsidiaries,
                users: action.payload.users,
                range: action.payload.range
            })
        );

        const userIds: number[] = vppsResponse.data["results"].reduce(
            (accumulator, activity) => {
                if (activity.user && !accumulator.includes(activity.user)) {
                    accumulator.push(activity.user);
                }
                return accumulator;
            },
            []
        );

        if (userIds.length > 0) {
            try {
                const usersResponse = yield call(() =>
                    vppsAPI.getVppsUsersById({
                        ids: userIds
                    })
                );

                vppsResponse.data["results"] = vppsResponse.data["results"].map(
                    log => {
                        log.user = _.find(usersResponse.data["results"], {
                            id: log.user
                        });
                        return log;
                    }
                );

                yield put({
                    type: VppsActionTypes.GET_VPPS_SUCCESS,
                    payload: {
                        vpps: vppsResponse.data,
                        users: usersResponse.data
                    }
                });
            } catch (e) {
                API.handleError(e.response, "Error getting Users Info.");

                yield put({
                    type: VppsActionTypes.GET_VPPS_FAIL,
                    message: e.message
                });
            }
        } else {
            yield put({
                type: VppsActionTypes.GET_VPPS_SUCCESS,
                payload: {
                    vpps: vppsResponse.data,
                    users: {
                        results: [],
                        count: 0
                    }
                }
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting Vpps.");

        yield put({
            type: VppsActionTypes.GET_VPPS_FAIL,
            message: e.message
        });
    }
}

export function* getVppsWatcher() {
    yield takeLatest(VppsActionTypes.GET_VPPS, getVpps);
}
